import React from "react";

export default function SQLServer_POWER() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_POWER</h1>
      <p>This is the SQLServer_POWER component generated from the SQL JSON.</p>
    </div>
  );
}
